import { action } from 'easy-peasy';

import { IActionRemoveMember } from '../types';

const removeMember: IActionRemoveMember = action((state, { channelUrl, userIds }) => {
  const channel = state.channels.find(item => item.url === channelUrl);

  if (channel) {
    channel.members = channel.members.filter(member => !userIds.includes(member.userId));
  }
});

export default removeMember;
